module.exports = {
  stylePrefix: 'rte-',

  // If true, moves the toolbar below the element when the top canvas
  // edge is reached
  adjustToolbar: 1,

  // Default RTE actions
  actions: ['bold', 'italic', 'underline', 'strikethrough', 'link']
};
